<div *ngIf="!!(networkConnection === 'SLOW')" class="text-dark bg-warning text-center fs-14 py-1 d-flex align-items-center justify-content-center gap-2 sticky-top">
  <iconify [name]="'iconoir:wifi'"></iconify>
  Slow Network Connection
</div>
<div *ngIf="!!(networkConnection === 'OFFLINE')" class="text-white bg-danger text-center fs-14 py-1 d-flex align-items-center justify-content-center gap-2 sticky-top">
  <iconify [name]="'iconoir:wifi-xmark'"></iconify>
  No Network Connection (offline)
</div>
